'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { getInitialMessageBubbleVisible } from './getInitialMessageBubbleVisible';
import { getShowInitialMessage } from '../../selectors/getShowInitialMessage';
import { getIsOpen } from '../../selectors/getIsOpen';
import { hasPersistedThreads } from '../../threads/selectors/hasPersistedThreads';
import { getThreadsAsyncData } from '../../threads/selectors/getThreadsAsyncData';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { isSucceeded, isUninitialized, isStarted } from 'conversations-async-data/async-data/operators/statusComparators';
export const getShowInitialMessageBubble = createSelector([getShowInitialMessage, getInitialMessageBubbleVisible, getIsOpen, getThreadsAsyncData, hasPersistedThreads, getIsAIChatbot], (showInitialMessage, initialMessageBubbleVisible, isOpen, threadsAsyncData, persistedThreads, isAIChatbot) => {
  // Don't show bubble while loading thread data
  if (isUninitialized(threadsAsyncData) || isStarted(threadsAsyncData)) {
    return false;
  }
  // Don't show bubble if persistedThreads exist
  if (isSucceeded(threadsAsyncData) && persistedThreads) return false;

  // For AI chatbot flows, bypass initialMessageBubbleVisible check
  if (isAIChatbot) {
    return showInitialMessage && !isOpen;
  }

  // For non-AI flows, use the original logic with initialMessageBubbleVisible
  return showInitialMessage && initialMessageBubbleVisible && !isOpen;
});